<template src="./selectpipe.html"></template>

<script>
  import { labelForMaterialTypeInCatalog } from '../../../../helpers/quoteMaterialTypeLabel'
  import SubNavigationBar from '../../../common/SubNavigationBar.vue'
  import { toTitleCase, titleCaseCatalogItem } from '../../../../helpers/titleCase'

  export default {
    name: 'material',
    components: {
      'app-sub-navigation-bar': SubNavigationBar
    },
    props: {
      parent_materials: {
        type: Array
      },
      calculation: {
        type: Object
      }
    },
    computed: {
      materials: function () {
        if (this.filtered !== null) {
          return this.filtered
        }

        return this.parent_materials
      },
      loading () {
        return this.parent_materials.length === 0
      },
      /** Catalog rows for types present on this task’s products (handles missing DB `type` on materials). */
      pipeTypeSelectItems () {
        const catalog = this.$store.getters['material/getTypePipe'] || []
        const mats = this.parent_materials || []
        const ids = [...new Set(
          mats.map((m) => {
            if (m.type != null && m.type !== '') return m.type
            return null
          }).filter((t) => t != null && t !== '')
        )]
        const allTypes = this.$store.getters['material/getTypes'] || []
        let items = ids.map((id) => {
          const sample = mats.find((m) => String(m.type) === String(id))
          return {
            id: Number(id) || id,
            name: labelForMaterialTypeInCatalog(catalog, id, sample, allTypes)
          }
        })
        items.sort((a, b) => String(a.name || '').localeCompare(String(b.name || '')))
        if (items.length === 0 && mats.length > 0) {
          items = [{ id: '__all__', name: 'All in this task' }]
        }
        return items
      }
    },
    data: function () {
      return {
        search: null,
        filtered: null
      }
    },
    methods: {
      /** Match material.type to catalog type id (HTML <select> uses string values; API may use numbers). */
      typesMatch (a, b) {
        if (a == null || b === '' || b == null) return false
        return String(a) === String(b)
      },
      filterByDescription: function (text) {
        if (text === '' || text == null) {
          this.filtered = null
          return
        }

        this.filtered = this.parent_materials.filter((item) => {
          return item.description.toLowerCase().indexOf(text.toLowerCase()) !== -1
        })
      },
      filterByType: function (type) {
        if (type === '' || type == null || type === '__all__') {
          this.filtered = null
          return
        }

        this.filtered = this.parent_materials.filter((item) => {
          return this.typesMatch(item.type, type)
        })
      },
      filterBySize: function (size) {
        if (size.id === '') {
          this.filtered = null
          return
        }

        let sizeObject = this.$store.getters['material/getSize'].filter((item) => {
          return size.id === item.id
        })

        this.filtered = this.parent_materials.filter((item) => {
          return (item.size >= sizeObject[0].prev + 1 && item.size <= sizeObject[0].id)
        })
      },
      getTypeName: function (id) {
        return this.$store.getters['material/getTypePipe'].filter((type) => {
          return type.id === id
        })[0].name
      },
      displayCatalogName: function (value) {
        return toTitleCase(value)
      },
      setPipe: function (pipe) {
        this.$emit('payload', { payload: titleCaseCatalogItem(pipe), calculation: this.calculation })
        this.$emit('close')
      },
    }
  }
</script>

<style scoped>

</style>
